var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxBoldBezier(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 9c1.1 0 2-.9 2-2s-.9-2-2-2c-.85 0-1.57.53-1.86 1.28-.05-.01-.09-.03-.14-.03h-4V5.5c0-.82-.68-1.5-1.5-1.5h-3C9.68 4 9 4.68 9 5.5v.75H5c-.05 0-.09.02-.14.03A1.992 1.992 0 0 0 3 5c-1.1 0-2 .9-2 2s.9 2 2 2c.85 0 1.57-.53 1.86-1.28.05.01.09.03.14.03h2.57c-2.05 1.52-3.32 4.04-3.32 6.75 0 .17.01.33.03.5H4c-.83 0-1.5.67-1.5 1.5v2c0 .83.67 1.5 1.5 1.5h2c.22 0 .42-.05.61-.14.52-.22.89-.75.89-1.36v-2c0-.83-.67-1.5-1.5-1.5h-.23c0-.03.01-.06.01-.09-.02-.14-.02-.27-.02-.41 0-2.47 1.27-4.73 3.26-5.9.04.77.69 1.4 1.48 1.4h3c.79 0 1.44-.63 1.49-1.4 1.99 1.17 3.26 3.44 3.26 5.9 0 .14-.01.27-.02.41 0 .03.01.06.01.09H18c-.83 0-1.5.67-1.5 1.5v2c0 .61.37 1.14.89 1.36.19.09.39.14.61.14h2c.83 0 1.5-.67 1.5-1.5v-2c0-.83-.67-1.5-1.5-1.5h-.28c.02-.17.03-.33.03-.5 0-2.71-1.27-5.23-3.32-6.75H19c.05 0 .09-.02.14-.03C19.43 8.47 20.15 9 21 9z",
    fill: "{props.color}",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldBezier);
export default __webpack_public_path__ + "static/media/vuesax-bold-bezier.7320425cc9b8091f5d42a3dbcc14ddcd.svg";
export { ForwardRef as ReactComponent };